import React, { useEffect, useState } from "react";
import axios from "axios";
import './Home.css' 

const Home = ({setSelectedPage}) => {

    const [main, setMain] = useState({});
    const [photos, setPhotos] = useState([]);


    const fetchHomePhotos = async () => {
       

        try {
            const response = await axios.get(`/api/gallery/GethomePhotos`);

        setPhotos(response.data.urls);
        console.log(photos);
        } catch (error) {
            console.error("Error Fetching Photos: ", error);
        }
    }


    useEffect(() => {
        fetchHomePhotos();
    }, [])


    return (
        <div>
        <div className="hero">
            <div className="hero-content">
             <h2>Capturing the Essence of KSA – Cars, Events & Landscapes</h2>
             <button onClick={() => setSelectedPage('Hiring')}>Hire For Shoot</button>
             <button onClick= {()=> setSelectedPage('Email')}>Send Queries</button>
            </div>
            </div>
                <h4>Turning fleeting glimpses into timeless stories...</h4>
                <div className="gallery">
                    {photos.map((url, index) => (
                        <img key={index} src={url} alt={`Gallery ${index}`} className="gallery-photo"/>
                    ))}
            </div>
        </div>
    )

}

export default Home;